import React, { useRef } from 'react';
import { ArrowLeft, ArrowRight, CircleCheckBig, X } from 'lucide-react';
import Spacing from '../Spacing';
import { notify, can_visit } from "../../helpers";
import SchedulerDateTimeSection from '../Section/SchedulerDateTimeSection';
import MultiSelectWithSearch from '../MultiSelectWithSearch';
import MessageTemplateModal from './MessageTemplateModal';
import { Drawer } from 'vaul';

export default function CreateNewCampaignModal(props) {
  const {    
    openModal = {},
    setOpenModal = () => {},
    account_id,
    location_id,
    activeSchedulerTab = 1,
    setActiveSchedulerTab = () => {},
    schedulerForm = {},
    changeActiveTab = () => {},
    handleSchedulerInputChange = () => {},
    insuranceOptions = [],
    selectedInsuranceOptions = [],
    handleInsuranceOptionToggle = () => {},
    isTargetPatient = 1,
    setisTargetPatient = () => {},
    caregapOptions = [],
    selectedMeasures = [],
    handleQMToggle = () => {},
    handleCareGapsInputChange = () => {},
    selectedTemplate = "",
    handleSelectedTemplate = () => {},
    templates = [],
    templateMessage = "",
    setSchedulerForm = () => {},
    defaultValues = {},
    loadSchedulers = () => {},
    previousScrollPosition = 0,
  } = props;

  const dropdownRef = useRef(null);

  const handleDrawerClose = () => {
    setOpenModal(false);
    window.scrollTo(0, previousScrollPosition);
  };

  return (
    <div style={{ height: "100%" }} ref={dropdownRef}>
      <Drawer.Root open={openModal} onOpenChange={handleDrawerClose}>
        <Drawer.Trigger className="docpro_single_patiant_modal_btn">
        </Drawer.Trigger>
        <Drawer.Portal>
          <Drawer.Overlay className="docpro_drawer_overlay"/>
          <Drawer.Content className="docpro_drawer_content docpro_drawer_style_4 large_medium">
            <Drawer.Title className="sr-only">Confirmation Modal</Drawer.Title>
            <Drawer.Description className="sr-only">Confirmation to send message</Drawer.Description>
            <div className="docpro_modal_wrap docpro_modal_lg center">
              <div className="docpro_modal scheduler">
                <div style={{ background: 'var(--white)', height: '100%' }}>
                  <button
                    className="docpro_close_btn"
                    onClick={() => {
                      handleDrawerClose();
                      setSchedulerForm(defaultValues);
                    }}
                  >
                    <X />
                  </button>

                  {activeSchedulerTab === 1 && (
                    <div className="scheduler-campaign" style={{ marginTop: '1rem' }}>
                      <div className='flex items-center' style={{ justifyContent: 'center' }}>
                        <img src="/images/icons/mic.png" alt="mic-icon" width={100} />
                      </div>
                      <Spacing lg="10" sm="10" />
                      <h4 className="docpro_mb_0 text-center">Let's create a campaign</h4>
                      <Spacing lg="40" sm="40" />

                      <div className="campaign-name" style={{ textAlign: 'left', maxWidth: '600px', margin: 'auto' }}>
                        <label className="docpro_fw_500 docpro_primary_color">
                          What's your campaign name?
                        </label>
                        <input
                          type="text"
                          className="docpro_form_field size_sm"
                          placeholder="ex: healthfirst patients reminder for annual checkup"
                          name="campaign_name"
                          autoFocus
                          defaultValue={schedulerForm?.campaign_name}
                          onChange={handleSchedulerInputChange}
                        />
                      </div>
                      <Spacing lg="28" sm="28" />

                      <div style={{ maxWidth: '600px', margin: 'auto' }}>
                        <button
                          type="button"
                          className="docpro_bordered_btn docpro_fw_600 size_lg docpro_filed_btn w-full"
                          onClick={() => {
                            if (schedulerForm.campaign_name.length > 1) {
                              changeActiveTab(2);
                            } else {
                              notify("info", "Campaign must have a name.");
                            }
                          }}
                        >
                          Begin
                        </button>
                      </div>
                      <Spacing lg="40" sm="40" />
                      <Spacing lg="40" sm="40" />
                      <Spacing lg="40" sm="40" />
                    </div>
                  )}

                  {activeSchedulerTab === 2 && (
                    <div className="insurance_and_target_patinents" style={{ maxWidth: '600px', margin: 'auto', height: '100%' }}>
                      <div className="modal_height_100">
                        <div>
                          <h4 className="docpro_mb_0 text-center">Which patient <br />should receive SMS?</h4>
                          <Spacing lg="40" sm="40" />

                          <div className="scheduler-insurance">
                            <label className="docpro_fw_500 docpro_primary_color">
                              Patients who have these insurances:
                              {selectedInsuranceOptions.length > 0 && (
                                <span className="docpro_green_color docpro_fs_14">
                                  ({selectedInsuranceOptions.length})
                                </span>
                              )}
                            </label>
                            <Spacing lg="5" sm="5" />
                            <MultiSelectWithSearch 
                              placeholder="Choose insurance"
                              style={{ width: "100%" }}
                              showSearch={true}
                            >
                              {insuranceOptions.map((insurance) => (
                                <li
                                  key={insurance.id}
                                  onClick={() =>
                                    handleInsuranceOptionToggle("insurance_ids", insurance.id)
                                  }
                                >
                                  <div
                                    className="docpro_checkbox"
                                    style={{ top: "3px" }}
                                  >
                                    <input
                                      type="checkbox"
                                      checked={selectedInsuranceOptions.includes(insurance.id)}
                                      readOnly
                                      value={insurance.id}
                                    />
                                    <label>
                                      <span style={{ marginLeft: "8px" }}>
                                        {insurance.name}
                                      </span>
                                    </label>
                                  </div>
                                </li>
                              ))}
                            </MultiSelectWithSearch>
                          </div>
                          <Spacing lg="25" sm="25" />

                          <div className="target_patient">
                            <label className="docpro_fw_500 docpro_primary_color">
                              Target patients By:
                            </label>
                            <Spacing lg="5" sm="5" />
                              <div className="docpro_tab_btns_2">
                                <button
                                  type="button"
                                  className={`${isTargetPatient === 1 ? "active" : ""}`}
                                  onClick={() => setisTargetPatient(1)}
                                >
                                  High Risk
                                </button>
                                <button
                                  type="button"
                                  className={`${isTargetPatient === 2 ? "active" : ""}`}
                                  onClick={() => setisTargetPatient(2)}
                                >
                                  Care Gaps
                                </button>
                              </div>
                              <Spacing lg="16" sm="16" />
                              <div
                                className="custom-scroll"
                                style={{
                                  maxHeight: "30vh",
                                  overflowY: "auto",
                                  marginBottom: 0,
                                }}
                              >
                                {isTargetPatient === 1 && (
                                  <>
                                    <p><span className="docpro_green_color docpro_fs_14" style={{marginRight:"5px"}}><CircleCheckBig/></span>All high-risk patients selected.</p>
                                    <Spacing lg="40" sm="40" />
                                    <Spacing lg="30" sm="30" />
                                  </>
                                )}
                                {isTargetPatient === 2 && (
                                  <>
                                    <ul style={{ listStyle: "none", paddingLeft: "10px" }}>
                                      {caregapOptions.map((item) => (
                                        <li key={item.id} style={{ marginBottom: "5px" }}>
                                          <div style={{ display: "block" }}>
                                            <div className="docpro_checkbox"  style={{ top: "3px" }}>
                                              <input
                                                type="checkbox"
                                                value={item.id}
                                                name="caregaps_id_list"
                                                defaultChecked={selectedMeasures?.some(
                                                  (measure) => measure.id === item.id
                                                )}
                                                onChange={(e) => {
                                                  const id = parseInt(e.target.value, 10);
                                                  const isChecked = e.target.checked;
                                                  handleQMToggle(id, isChecked, "pending");
                                                  handleCareGapsInputChange(e);
                                                }}
                                                style={{ width: '100%' }}
                                              />
                                              <label style={{ marginLeft: "1rem",width:"100%",display:"block" }}> {item.name} </label>
                                            </div>

                                            <select
                                              name="status"
                                              data-care-gap-id={item.id}
                                              style={{
                                                paddingRight: "24px",
                                                marginLeft: "10px",
                                                border: 0,
                                                borderBottom: "1px solid #d3d4db",
                                                borderRadius: 0,
                                              }}
                                              value={
                                                selectedMeasures?.find((measure) => measure.id === item.id)
                                                  ?.status || "pending"
                                              }
                                              onChange={(e) => {
                                                const newStatus = e.target.value;
                                                const id = item.id;
                                                const isChecked = true;
                                                handleQMToggle(id, isChecked, newStatus);
                                                handleCareGapsInputChange(e);
                                              }}
                                            >
                                              <option value="pending">Pending</option>
                                              <option value="completed">Done</option>
                                            </select>
                                          </div>
                                        </li>
                                      ))}
                                    </ul>
                                  </>
                                )}
                              </div>
                          </div>

                          <Spacing lg="20" sm="20" />
                        </div>
                        <div className="docpro_scheduler_page_btn" style={{ width: '100%', margin: 'auto 0 0 0' }}>
                          <button type="button"
                            onClick={() => {changeActiveTab(1);}}
                            className="docpro_bordered_btn docpro_fw_600 size_lg"
                          >
                            <ArrowLeft width={16} height={16} className="mr-2" />
                            <span>Back</span>
                          </button>
                          <button
                            type="button"
                            onClick={() => {changeActiveTab(3);}}
                            className="docpro_bordered_btn docpro_fw_600 docpro_filed_btn size_lg"
                          >
                            <span className="mr-2">Next</span>
                            <ArrowRight width={16} height={16} />
                          </button>
                        </div>
                      </div>
                    </div>
                  )}

                  {activeSchedulerTab === 3 && (
                    <div className="scheduler_message_template setup-scheduler-page">
                      <h4 className="docpro_mb_0">What text do you want to send out?</h4>
                      <Spacing lg="30" sm="30" />

                      <div className="docpro_grid docpro_grid_col_2">
                        <div className="docpro_card_1" style={{ textAlign: 'left' }}>
                          <p className="docpro_mb_0">All patients will receive SMS based on your filters. </p>
                          <Spacing lg="20" sm="20" />

                          <div className="">
                            <div className='bulk_message_footer'>
                              <strong
                                className="docpro_secondary_color"
                                style={{ fontFamily: "var(--primary-font)" }}
                              >
                                Pick from our SMS templates
                              </strong>
                              {(can_visit("messages") && can_visit("messages_message_templates_create")) && (
                                <MessageTemplateModal account_id={account_id} editModal={false} schedulerPage={true} />
                              )}
                            </div>
                            <Spacing lg="10" sm="10" />
                            <select className="docpro_form_field size_lg" value={selectedTemplate} onChange={handleSelectedTemplate}>
                              <option value="" disabled>
                                Select a Template
                              </option>
                              {templates.map((item, index) => (
                                <option key={index} value={item.title}>
                                  {item.title}
                                </option>
                              ))}
                            </select>
                            <Spacing lg="20" sm="20" />
                            <div className="">
                              <label className="docpro_fw_500 docpro_primary_color"> Message <span className="docpro_fs_18" style={{marginRight:"5px",color:"var(--red)"}}>*</span></label>
                              <textarea
                                value={templateMessage}
                                name="message_body"
                                className="docpro_form_field size_lg"
                                style={{resize:"none"}}
                                cols="30"
                                rows="10"
                                required
                                autoFocus
                                onChange={handleSchedulerInputChange}
                              />
                              <Spacing lg="30" sm="30" />
                            </div>
                          </div>

                          <div className="docpro_scheduler_page_btn" style={{ width: '100%' }}>
                            <button type="button"
                              onClick={() => {changeActiveTab(2);}}
                              className="docpro_bordered_btn docpro_fw_600 size_lg"
                            >
                              <ArrowLeft width={16} height={16} className="mr-2" />
                              <span>Back</span>
                            </button>
                            <button
                              type="button"
                              onClick={() => {
                                if (templateMessage) {
                                  setActiveSchedulerTab(4);
                                  setSchedulerForm({...schedulerForm,message_body:templateMessage})
                                }
                                else{
                                  notify("info", "Message is Required!");
                                }
                              }}
                              className="docpro_bordered_btn docpro_fw_600 docpro_filed_btn size_lg"
                            >
                              <span className="mr-2">Next</span>
                              <ArrowRight width={16} height={16} />
                            </button>
                          </div>
                        </div>

                        <div className="docpro_card_1 template_message_mobile">
                          <img src="/images/phone_case.png" alt="Mobile Phone Case" />
                          <div className="" style={{padding: "6px"}}>
                            {templateMessage ? <p> {templateMessage}</p> : <p>Choose a template or write message</p>}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  {activeSchedulerTab === 4 && (
                    <SchedulerDateTimeSection
                      templateMessage={templateMessage}
                      handleSchedulerInputChange={handleSchedulerInputChange}
                      schedulerForm={schedulerForm}
                      setSchedulerForm={setSchedulerForm}
                      defaultValues={defaultValues}
                      setActiveSchedulerTab={setActiveSchedulerTab}
                      reloadData={loadSchedulers}
                      account_id={account_id}
                      location_id={location_id}
                      setOpenModal={handleDrawerClose}
                    />
                  )}
                </div>
              </div>
            </div>
          </Drawer.Content>
        </Drawer.Portal>
      </Drawer.Root>
    </div>
  );
}
